module.exports = __webpack_public_path__ + "static/media/consolidation-alert.cd608d2b.wav";